import { Link } from "react-router-dom";
import styled from "@emotion/styled";

export const CustomLink = styled(Link)`
  text-decoration: none;
  color: black;
`;
